export default __webpack_public_path__ + "static/media/tubuva_ru.bfaeae94.jpg";